import React from "react";

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

import "./Memberships.scss";

const breadcrumbsStatic = [
	{
		name: "Memberships",
		url: "/memberships",
		icon: "id-card-o",
	},
];

export default class Membership extends Framework.Components.View {
	constructor(props) {
		super(props, "details");
		this.state.name = "";
	}

	componentDidMount = () => {
		window.scrollTo(0, 0);
	};

	refreshPage = () => {
		this.setState({
			key: Math.random(),
			refresh: !this.state.refresh,
		});
	};

	render() {
		const {match, history, baseUrl} = this.props;
		const breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name || "Membership",
				url: `/memberships/${match.params.id}`,
				icon: "edit",
			},
		]);

		return (
			<div className="container-fluid memberships-page">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>
				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Objects.Membership
						key={this.state.key}
						id={match.params.id}
						roles={this.props.roles}
						history={history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={(name) => this.setState({name})}
						baseUrl={baseUrl}
						dataIdSave="membership-save"
						dataIdDelete="membership-delete"
					/>
				</Framework.Errors.General>
			</div>
		);
	}
}
